(function () {
  function initPortfolio(root) {
    var dataNode = root.querySelector('[data-osh-portfolio-data]');
    var lightbox = root.querySelector('[data-osh-portfolio-lightbox]');
    if (!dataNode || !lightbox) return;

    var galleries;
    try {
      galleries = JSON.parse(dataNode.textContent || '[]');
    } catch (error) {
      return;
    }

    var image = lightbox.querySelector('[data-osh-lightbox-image]');
    var title = lightbox.querySelector('[data-osh-lightbox-title]');
    var meta = lightbox.querySelector('[data-osh-lightbox-meta]');
    var count = lightbox.querySelector('[data-osh-lightbox-count]');
    var previous = lightbox.querySelector('[data-osh-lightbox-prev]');
    var next = lightbox.querySelector('[data-osh-lightbox-next]');
    var closeButtons = lightbox.querySelectorAll('[data-osh-lightbox-close]');
    var closeButton = lightbox.querySelector('.osh-portfolio-lightbox__close');
    var activeGallery = 0;
    var activeImage = 0;
    var lastFocus = null;

    function currentGallery() {
      return galleries[activeGallery] || null;
    }

    function updateLightbox() {
      var gallery = currentGallery();
      if (!gallery || !gallery.images || !gallery.images.length) return;
      var photo = gallery.images[activeImage] || gallery.images[0];
      image.src = photo.src;
      image.alt = photo.alt || gallery.title;
      title.textContent = gallery.title;
      meta.textContent = [gallery.location, gallery.services.join(' / '), gallery.brands.join(' · ')].filter(Boolean).join(' - ');
      count.textContent = String(activeImage + 1).padStart(2, '0') + ' / ' + String(gallery.images.length).padStart(2, '0');
      var single = gallery.images.length < 2;
      previous.hidden = single;
      next.hidden = single;
    }

    function focusableElements() {
      return Array.prototype.slice.call(lightbox.querySelectorAll("a[href], button:not([disabled]):not([hidden]), [tabindex]:not([tabindex='-1'])")).filter(function (el) {
        return el.tabIndex >= 0 && !el.hidden && (el.offsetParent !== null || el === document.activeElement);
      });
    }

    function trapFocus(event) {
      if (event.key !== 'Tab') return;
      var items = focusableElements();
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function openLightbox(galleryIndex) {
      if (!galleries[galleryIndex]) return;
      activeGallery = galleryIndex;
      activeImage = 0;
      lastFocus = document.activeElement;
      updateLightbox();
      lightbox.hidden = false;
      lightbox.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('osh-lightbox-open');
      if (closeButton) closeButton.focus();
    }

    function closeLightbox() {
      lightbox.hidden = true;
      lightbox.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('osh-lightbox-open');
      if (lastFocus && typeof lastFocus.focus === 'function') {
        lastFocus.focus();
      }
    }

    function step(direction) {
      var gallery = currentGallery();
      if (!gallery || !gallery.images || gallery.images.length < 2) return;
      activeImage = (activeImage + direction + gallery.images.length) % gallery.images.length;
      updateLightbox();
    }

    root.querySelectorAll('[data-osh-gallery-index]').forEach(function (card) {
      card.addEventListener('click', function () {
        openLightbox(Number(card.getAttribute('data-osh-gallery-index') || 0));
      });
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeLightbox);
    });

    previous.addEventListener('click', function () {
      step(-1);
    });

    next.addEventListener('click', function () {
      step(1);
    });

    document.addEventListener('keydown', function (event) {
      if (lightbox.hidden) return;
      trapFocus(event);
      if (event.key === 'Escape') closeLightbox();
      if (event.key === 'ArrowLeft') step(-1);
      if (event.key === 'ArrowRight') step(1);
    });
  }

  function init() {
    document.querySelectorAll('[data-osh-portfolio]').forEach(initPortfolio);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
